/**
 * Whether the app is running as an installed PWA in a standalone window (home-
 * screen launch) rather than a regular browser tab.
 *
 * The "sign in every time" complaints are concentrated in installed PWAs (a
 * cold home-screen launch is a full document navigation that hits the service
 * worker / middleware login path), so auth analytics tag events with this to
 * tell PWA re-logins apart from browser ones. iOS exposes it via the legacy
 * `navigator.standalone`; everyone else via the `display-mode` media query.
 */
export function isStandaloneDisplay(): boolean {
  if (typeof window === 'undefined') return false
  return (
    window.matchMedia?.('(display-mode: standalone)').matches === true ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  )
}
